<template>
  <div :class="['content']" :style="`background: ${$store.state.news.color}; color: ${($store.state.news.user || {}).textColor || '#fff'}`">
    <Marquee />
    <div class="text">{{ text }}</div>

    <div :class="['img', showSmall, overflow]">
      <Qr :showLabel="false" code="http://google.com" :color="'#fff'" />
    </div>
    <div :class="['logo logo3', logoShow]"><img :src="$store.state.news.logo" width="100%"></div>
  </div>
</template>

<script>
import Qr from '../template1/Qr.vue'
import Marquee from './marquee.vue';
export default {
  components: {Qr, Marquee},
  data: () => ({
    logoShow: '',
    showSmall: '',
    overflow: '',
    text: "",
  }),
  computed:{
    originalText(){
      return 'Aponte a câmera do seu celular para o código QR abaixo e confira a reportagem completa!'
    }
  },
  methods: {
    async write(idx) {
      for (var i = (idx || 0); i < this.originalText.length; i++) {
        if (!this.$store.state.previews.play) {
          if(this.stopWrite) return;
          await this.timeout(this.$store.state.previews.timeWrite)
          this.write(i)
          return;
        }
        await this.timeout(this.$store.state.previews.timeWrite);
        this.text += this.originalText[i];
      }
      if(!this.$store.state.previews.play) return;
      await this.timeout(this.$store.state.previews.timeStage2)
      this.$emit('end')
    },
    timeout(time) {
      return new Promise((resolve) => setTimeout(resolve, time || 1000));
    },
  },

  mounted() {
    setTimeout(()=>this.showSmall='show-small',50)
    setTimeout(()=>{
      this.logoShow = 'logo-show'
      this.overflow='overflow'
      }, 1000)
    this.write();
  },
};
</script>

<style  scoped>

.content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fb611c;
  font-family: tn;
}

.content *{
  transition: all .5s ease;
}

.logo{
  position: absolute;
  width: 400px;
  height: 300px;
  text-align: center;
  transition: all 1s ease;
  opacity: 0;
}

.logo-show{
  opacity: 1;
}

.logo3{
  bottom: 250px;
  left: 340px;
  width: 400px;
  height: 200px;
}

.text {
  top: 80px;
  padding:220px;
  text-align: center;
  font-size: 40pt!important;
  position: absolute;
  line-height: 100px;
}

.img {
  position: absolute;
  height: 0px;
  width: 0px;
  left: 240px;
  top: 800px;
  transform: translate(0, 0);
  animation: wave 10s infinite linear;
  overflow: hidden;
  /* transition: all 0.5s; */
  background: #fff;
  /* border-radius: 100% 30% 80% 50%; */
}

.show-small{
  height: 600px;
  width: 600px;
}

.overflow{
  overflow: initial
}

@keyframes wave {
  0% {
    border-radius: 60% 80% 80% 50%;
  }

  20% {
    border-radius: 100% 50% 50% 80%;
  }

  40% {
    border-radius: 30% 70% 10% 70%;
  }

  60% {
    border-radius: 88% 50% 80% 50%;
  }

  80% {
    border-radius: 60% 80% 90% 100%;
  }

  100% {
    border-radius: 60% 80% 80% 50%;
  }
}
</style>